// extracted by mini-css-extract-plugin
export default {"cls1":"Popover-cls1_CNS","cls2":"Popover-cls2_N2H Popover-cls1_CNS","inline":"Popover-inline_M0Z"};